import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from "vue"; // ref, computed, watch 임포트
import {
  NConfigProvider,
  NMessageProvider,
  NNotificationProvider,
  NDialogProvider,
  koKR, // 한국어 로케일
  dateKoKR, // 한국어 날짜 로케일
  enUS, // 영어 로케일 (예시)
  dateEnUS, // 영어 날짜 로케일 (예시)
  // 필요한 다른 언어 로케일들도 임포트
} from "naive-ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentLanguage = ref(localStorage.getItem("userLanguage") || "ko"); // 기본값 'ko'

const naiveUiLocales = {
  ko: { locale: koKR, dateLocale: dateKoKR },
  en: { locale: enUS, dateLocale: dateEnUS },
};

const currentLocale = computed(() => {
  return (
    naiveUiLocales[currentLanguage.value as keyof typeof naiveUiLocales] ||
    naiveUiLocales.ko
  ); // 지원하지 않는 언어일 경우 기본값(한국어)
});

watch(currentLanguage, (newLang) => {
  localStorage.setItem("userLanguage", newLang);
});

function changeLanguage(lang: string) {
  currentLanguage.value = lang;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    locale: currentLocale.value.locale,
    "date-locale": currentLocale.value.dateLocale
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NMessageProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NNotificationProvider), { placement: "top" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NDialogProvider), null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale", "date-locale"]))
}
}

})